import "./App.css";
import { css } from "@emotion/react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import {
  Bluray,
  LatestInfos,
  Twitter,
  OriginalInfo,
  Story,
  Author,
  Casts,
  Staff,
  Schedule,
  Tickets,
  Map,
  Guidance,
  Trailer,
  GoodsInfo,
  Fotter,
  HumburgerMenu,
  BackgroundSakura,
} from "./components/molecules";
import SchedulePage from "./SchedulePage";

function Home() {
  return (
    <>
      <HumburgerMenu />
      <BackgroundSakura />
      <div css={topContainerStyle}>
        <img
          src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/home.png"}
          css={homeImgStyle}
          alt="home-img"
        />
        <div css={namesTxtWrapperStyle}>
          <div css={namesTxtStyle}>
            © 森本梢子／集英社　©Culture Entertainment Co.,Ltd.
          </div>
        </div>
      </div>
      <Bluray />
      <LatestInfos />
      <Twitter />
      <OriginalInfo />
      <Trailer />
      <Story />
      <Author />
      <Casts />
      <Staff />
      <Schedule />
      <Tickets />
      <GoodsInfo />
      <Map />
      <Guidance />
      <Fotter />
    </>
  );
}

function App() {
  return (
    <div className="App" css={appStyle}>
      <Router basename={process.env.REACT_APP_BASE_PATH}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/schedule" element={<SchedulePage />} />
        </Routes>
      </Router>
    </div>
  );
}

const primaryColor = "#DD6B74";

const appStyle = css`
  min-height: 100vh;
  background: linear-gradient(
    to right,
    rgba(248, 204, 197, 0.63) 0%,
    rgba(250, 211, 202, 0.4) 33%,
    rgba(243, 170, 178, 0.54) 100%
  );
  color: ${primaryColor};
  font-family: "游明朝", "Yu Mincho", YuMincho, "Hiragino Mincho Pro", serif;
  overflow-x: hidden;
`;

const topContainerStyle = css`
  width: 100%;
  padding-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const homeImgStyle = css`
  width: 95%;
  max-width: 500px;
`;

const namesTxtWrapperStyle = css`
  width: 100%;
  max-width: 500px;
  text-align: right;
`;

const namesTxtStyle = css`
  margin: 20px 15px 3px;
  font-size: 5pt;
`;

export default App;
